<script>
import Filters from './Filters.vue';
import Areas from './Areas.vue';
import SearchInput from './SearchInput.vue';
import Hits from './Hits.vue';

export default {
  props: [
    'overlap',
    'url',
    'initSearch',
    'settings',
    'theme',
    'areas',
    'filters',
    'componentTexts',
  ],
  data() {
    return {
      colors: {
        filter: '',
        title: '',
      },
      strings: this.componentTexts ? this.componentTexts : {},
      defaultSettings: {
        FreeText: '',
        Area: 'Alla områden',
        SearchCourse: false,
        SearchProgram: false,
        Facets: {
          IsOpen: true,
          TermStart: [],
          Period: [],
          StudyLocation: [],
          StudyPace: [],
          StudyForm: [],
          Level: [],
        },
      },
      searchResults: undefined,
      alwaysShownFilters: [],
      filtersAreOpen: false,
      hasDefaultArea: '',
      hasDefaultQueryText: '',
      url: this.url && this.url,
      doInitSearch: this.initSearch,
      storageKey:
        typeof window !== undefined &&
        `${window.location.pathname}-education-block-settings`,
      request: this.settings
        ? this.settings
        : {
            FreeText: '',
            Area: 'Alla områden',
            SearchCourse: false,
            SearchProgram: false,
            Facets: {
              IsOpen: true,
              TermStart: [],
              Period: [],
              StudyLocation: [],
              StudyPace: [],
              StudyForm: [],
              Level: [],
            },
          },
      searchHitCount: 0,
      activeFilters: [],
      skipLabel: 'Hoppa över utbildningssöken och dess sökträffar',
      skipTargetLabel: 'Efter utbildningssök',
    };
  },
  async created() {
    await import(
      /* webpackChunkName: "forms" */ '../../../static/js/loaders/collapse.js'
    );
  },
  mounted() {
    const htmlElement = document.documentElement;
    if (htmlElement?.lang === 'en') {
      this.skipLabel = 'Skip the education search and its search hits';
      this.skipTargetLabel = 'After education search';
    }

    this.atInit();
    // fix margin overlap
    if (this.overlap) {
      const block = document.getElementById('searchprogramcomponent');
      if (block) {
        const title = document.getElementById('search--title');
        block.style.marginTop = title ? `-${title.offsetHeight}px` : '-113px';
      }
    }
  },
  components: {
    Filters,
    Areas,
    SearchInput,
    Hits,
  },
  methods: {
    updateQuery(value) {
      this.request = value;
    },
    atInit() {
      this.theme && this.initTheme(this.theme);
      this.applyLocalSetting();
      this.applyFilters();
      this.filters && (this.alwaysShownFilters = this.filters.splice(0, 4));
      if (this.doInitSearch) {
        this.fetchApi(this.url, this.request);
      }
    },
    applyFilters() {
      this.request.Area != 'Alla områden' &&
        (this.hasDefaultArea = this.request.Area);
      this.request.FreeText &&
        (this.hasDefaultQueryText = this.request.FreeText);
      this.request.SearchCourse && this.activeFilters.push('SearchCourse');
      this.request.SearchProgram && this.activeFilters.push('SearchProgram');

      const facets = this.request.Facets
        ? this.request.Facets
        : this.defaultSettings.Facets;
      Object.keys(facets).forEach((key) => {
        if (key == 'IsOpen' && facets[key]) {
          const isOpen = this.filters.find((f) => f.key == key);
          isOpen &&
            isOpen.values.forEach((v) => {
              this.activeFilters.push(v);
            });
        } else {
          facets[key] &&
            facets[key].forEach((f) => {
              this.activeFilters.push(f);
            });
        }
      });
    },
    applyLocalSetting() {
      const settings = localStorage.getItem(this.storageKey);
      if (!settings) {
        return;
      }
      try {
        const parsed = JSON.parse(settings);
        if (Date.now() <= parsed.expire) {
          this.request = parsed.request;
          this.searchResults = parsed.searchResults;
        } else {
          localStorage.removeItem(this.storageKey);
        }
      } catch (err) {
        console.log(err);
      }
    },
    setLocalSettings(expireAfter) {
      const item = {
        request: this.request,
        searchResults: this.searchResults,
        expire: Date.now() + expireAfter * 60000,
      };
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(item));
      } catch (err) {
        console.log({ err });
      }
    },
    initTheme(theme) {
      switch (theme) {
        case 'blue':
          this.colors = {
            filter: 'filter--selected-blue',
            title: 'title--white',
          };
          break;
        case 'yellow':
          this.colors = {
            filter: 'filter--selected-black',
            title: 'title--black',
          };
          break;
        case 'orange':
          this.colors = {
            filter: 'filter--selected-black',
            title: 'title--white',
          };
          break;
        case 'green':
          this.colors = {
            filter: 'filter--selected-black',
            title: 'title--black',
          };
          break;
        default:
          this.colors = {
            filter: 'filter--selected-black',
            title: 'title--black',
          };
          break;
      }
    },
    userSubmit() {
      this.fetchApi(this.url, this.request);
    },
    updateFacetValue(key, value, removeFromArr) {
      switch (key) {
        case 'IsOpen':
          this.request.Facets.IsOpen = !this.request.Facets.IsOpen;
          break;
        default:
          if (removeFromArr) {
            const index = this.request.Facets[key].indexOf(value);
            this.request.Facets[key].splice(index, 1);
          } else {
            this.request.Facets[key].push(value);
          }
          break;
      }
    },
    updateRequest(key, value, isFacet, updateActiveFilters = true) {
      const index = this.activeFilters.indexOf(isFacet ? value : key);
      isFacet
        ? this.updateFacetValue(key, value, index != -1)
        : (this.request[key] = value);
      if (updateActiveFilters) {
        index == -1
          ? this.activeFilters.push(isFacet ? value : key)
          : this.activeFilters.splice(index, 1);
      }
      key != 'FreeText' && this.fetchApi(this.url, this.request);
    },
    async fetchApi(url, request) {
      // request.Area = 'Alla områden';
      try {
        const res = await fetch(url, {
          method: 'post',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json;charset=UTF-8',
          },
          body: JSON.stringify(request),
        });
        const data = await res.json();
        data && (this.searchResults = data);
        data && this.setLocalSettings(15);
      } catch (error) {}
    },
    expandFilters() {
      this.filtersAreOpen = !this.filtersAreOpen;
    },
  },
  watch: {
    request: {
      handler(val, oldVal) {},
      deep: true,
    },
  },
};
</script>

<template>
  <div class="search--container" :class="'theme--' + this.theme">
    <a href="#after-edu-list" class="skip-edu-link">{{ skipLabel }}</a>
    <div
      id="search--title"
      class="search--title opacity-96"
      :class="['bg-' + this.theme, this.colors.title]">
      <h2 class="heading-level-2" :class="this.colors.title">
        {{ strings.titleText }}
      </h2>
      <p :class="this.colors.title">
        {{ strings.preambleText }}
      </p>
    </div>

    <!-- <loadingcomponent
      v-if="!this.filters"
      :text="strings.loadingText"
    ></loadingcomponent> -->

    <div class="search--lowersection" :class="['bg-light-' + this.theme]">
      <div class="search--search">
        <Areas
          :initWithDefaultArea="hasDefaultArea ? hasDefaultArea : ''"
          class="areas"
          v-if="this.areas"
          @update-request="this.updateRequest"
          :areas="this.areas" />
        <SearchInput
          :initWithDefaultSearchTerm="hasDefaultQueryText"
          :text="strings.inputPlaceholderText"
          v-if="this.areas"
          class="search"
          @update-request="this.updateRequest"
          @user-submit="userSubmit" />
      </div>

      <div class="search--filters d-flex flex-column">
        <Filters
          v-if="this.alwaysShownFilters"
          @update-request="this.updateRequest"
          :filters="this.alwaysShownFilters"
          :activeFilters="this.activeFilters"
          :activeClass="this.colors.filter" />

        <transition mode="out-in" name="fade">
          <div
            class="search--filters--expanded d-flex flex-wrap"
            v-if="this.filtersAreOpen">
            <Filters
              v-if="this.filters"
              @update-request="this.updateRequest"
              :filters="this.filters"
              :activeFilters="this.activeFilters"
              :activeClass="this.colors.filter" />
          </div>
        </transition>

        <button
          type="button"
          v-if="this.filters"
          @click="expandFilters"
          class="d-flex flex-row button--filters align-items-center">
          <p class="button--text mb-0">{{ strings.moreFilterText }}</p>
          <transition name="fade" mode="out-in">
            <span v-if="filtersAreOpen" class="material-icons mr-1"
              >keyboard_arrow_up</span
            >
            <span v-else class="material-icons mr-1">keyboard_arrow_down</span>
          </transition>
        </button>
      </div>
    </div>

    <div v-if="this.searchResults" class="search--hits">
      <transition mode="out-in" name="fade">
        <Hits
          :searchResults="this.searchResults"
          :searchHitShowText="strings.searchHitShowText"
          :searchHitsText="strings.searchHitsText"
          :applicationOpenText="strings.applicationOpenText"
          :applicationClosedText="strings.applicationClosedText"
          :applicationLateText="strings.applicationLateText"
          :applicationCanceledText="strings.applicationCanceledText"
          :educationOccasionText="strings.educationOccasionText"
          :educationOccasionsText="strings.educationOccasionsText"
          :hitCourseText="strings.hitCourseText"
          :hitProgramText="strings.hitProgramText" />
      </transition>
      <transition mode="out-in" name="fade">
        <div
          class="nohits--container"
          v-if="this.searchResults.NumberOfHits === 0">
          <p
            :class="{
              'animated shake': this.searchResults.NumberOfHits === 0,
            }">
            {{ strings.nohitsText }}
          </p>
        </div>
      </transition>
    </div>
    <span id="after-edu-list" class="sr-only" tabindex="-1">{{
      skipTargetLabel
    }}</span>
  </div>
</template>
